import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "general__checkbox_checked",
  "use": "general__checkbox_checked-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"general__checkbox_checked\">\n  <g fill=\"none\">\n    <rect stroke-width=\"1.5\" x=\"1\" y=\"1\" width=\"16\" height=\"16\" rx=\"1\" />\n    <path d=\"M12.3 6.8 l-4.6 4.6 l-2.4 -2.4\" stroke-linecap=\"round\" stroke-width=\"1.5\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol